/**
 * @packageDocumentation
 * @module Datetime
 */
import { utcToZonedTime } from 'date-fns-tz';
import memoizeOne from 'memoize-one';
/**
 * Function to get a date object from a string and timezone
 * @param dateTimeString: string with the date to convert
 * @param timezone: Timezone for the conversion
 *
 * @return Date
 */
var zonedDateFromDateString = function (dateTimeString, timezone) { return utcToZonedTime(dateTimeString, timezone); };
var getZonedDateFromDateString = memoizeOne(zonedDateFromDateString);
export default getZonedDateFromDateString;
//# sourceMappingURL=getZonedDateFromDateString.js.map